import { AdminsScreen } from '../features/admins/AdminsScreen'
import { useShell } from '../app/outlet'

export function AdminsPage() {
  const { toast } = useShell()
  return <AdminsScreen onToast={toast} />
}
